import { ToastOptions } from 'react-hot-toast'

export const getToastOptions = (
    id: string,
    duration: number | undefined,
    ariaProps: ToastOptions['ariaProps'] | undefined
): ToastOptions => ({ id, duration, ...(ariaProps === undefined ? {} : { ariaProps }) })
